<template>
  <lottie
    :options="defaultOptions"
    :width="width"
    :height="height"
  />
</template>

<script>
import Lottie from 'vue-lottie'
import * as animationData from '@/assets/lottie/qr-code.json'

export default {
  name: 'QrCodeLoader',
  components: {
    Lottie,
  },
  props: {
    width: {
      type: [String, Number],
      default: () => 400,
    },
    height: {
      type: [String, Number],
      default: () => 400,
    },
  },
  data() {
    return {
      anim: null,
      defaultOptions: { animationData },
    }
  },
}
</script>

<style scoped>

</style>
